import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../store';
import { showNumberSelectionDialog } from '../../store/customer/actions';
import { CustomerState } from '../../store/customer/types';
import ActiveCustomerNumber from '../ActiveCustomerNumber';

const StyledSideBoxMenuHeader = styled.div`
    border-bottom: 1px solid #ccc;
    cursor: pointer;
`;

export interface SideBoxMenuHeaderProps {}

const SideBoxMenuHeader: React.FC<SideBoxMenuHeaderProps> = () => {
    const dispatch = useDispatch();
    const { activeCustomerNumber, customerNumbers } = useSelector<RootState, CustomerState>(
        (state) => state.customerDetail,
    );

    return (
        <StyledSideBoxMenuHeader className="side-box-menu" id="side-box-menu">
            {activeCustomerNumber && (
                <ActiveCustomerNumber
                    activeNumber={activeCustomerNumber}
                    totalOwnedNumber={customerNumbers.length}
                    onClick={() => dispatch(showNumberSelectionDialog())}
                />
            )}
        </StyledSideBoxMenuHeader>
    );
};

export default SideBoxMenuHeader;
